import moment from 'moment';

/**
 * Get date range for a preset type
 * @param {string} preset - One of: 'THIS_YEAR', 'LAST_YEAR', 'LAST_3_MONTHS', 'LAST_6_MONTHS', 'FIRST_SEMESTER', 'SECOND_SEMESTER', 'RESET'
 * @returns {{ startDate: string | null, endDate: string | null }} - Dates in YYYY-MM-DD format, or null for RESET
 */
export const getDateRangeForPreset = (preset) => {
  let minDate = null;
  let maxDate = null;

  switch (preset) {
    case 'THIS_YEAR':
      minDate = moment().startOf('year');
      maxDate = moment().endOf('year');
      break;
    case 'LAST_YEAR':
      minDate = moment().subtract(1, 'year').startOf('year');
      maxDate = moment().subtract(1, 'year').endOf('year');
      break;
    case 'LAST_3_MONTHS':
      minDate = moment().subtract(3, 'months').startOf('month');
      maxDate = moment().endOf('month');
      break;
    case 'LAST_6_MONTHS':
      minDate = moment().subtract(6, 'months').startOf('month');
      maxDate = moment().endOf('month');
      break;
    case 'FIRST_SEMESTER':
      minDate = moment().startOf('year');
      maxDate = moment().month(5).endOf('month'); // June (month 5, 0-indexed)
      break;
    case 'SECOND_SEMESTER':
      minDate = moment().month(6).startOf('month'); // July (month 6, 0-indexed)
      maxDate = moment().endOf('year');
      break;
    case 'RESET':
      return { startDate: null, endDate: null };
    default:
      return { startDate: null, endDate: null };
  }

  if (minDate && maxDate) {
    return {
      startDate: minDate.format('YYYY-MM-DD'),
      endDate: maxDate.format('YYYY-MM-DD'),
    };
  }

  return { startDate: null, endDate: null };
};


